import { motion, AnimatePresence } from "framer-motion";
import { X, Calendar, Info } from "lucide-react";

function NoticeModal({ notice, isOpen, onClose }) {
    if (!notice) return null;

    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    onClick={onClose}
                    style={{
                        position: 'fixed',
                        inset: 0,
                        background: 'rgba(4, 9, 96, 0.9)', // Branded deep navy overlay
                        zIndex: 9999,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backdropFilter: 'blur(12px)',
                        padding: '20px'
                    }}
                >
                    {/* Modal Content */}
                    <motion.div
                        initial={{ scale: 0.9, opacity: 0, y: 20 }}
                        animate={{ scale: 1, opacity: 1, y: 0 }}
                        exit={{ scale: 0.9, opacity: 0, y: 20 }}
                        transition={{ type: 'spring', damping: 25, stiffness: 300 }}
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            width: '100%',
                            maxWidth: '700px',
                            background: '#FFFFFF',
                            borderRadius: '12px',
                            boxShadow: '0 30px 60px rgba(0,0,0,0.5)',
                            overflow: 'hidden',
                            position: 'relative',
                            display: 'flex',
                            flexDirection: 'column'
                        }}
                    >
                        {/* Branded Header Accent */}
                        <div style={{
                            width: '100%',
                            height: '6px',
                            background: 'var(--yellow)'
                        }} />

                        {/* Top Bar */}
                        <div style={{
                            padding: '24px 32px 16px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                                color: 'var(--blue)',
                                fontFamily: 'var(--fontRajdhani)',
                                fontWeight: 800,
                                fontSize: '14px',
                                letterSpacing: '2px',
                                textTransform: 'uppercase'
                            }}>
                                <Info size={18} />
                                <span>OFFICIAL NOTICE</span>
                            </div>
                            
                            <motion.button
                                whileHover={{ rotate: 90, scale: 1.1 }}
                                whileTap={{ scale: 0.9 }}
                                onClick={onClose}
                                style={{
                                    background: 'rgba(0,0,0,0.05)',
                                    border: 'none',
                                    borderRadius: '50%',
                                    width: '36px',
                                    height: '36px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    color: 'var(--blue)'
                                }}
                            >
                                <X size={20} />
                            </motion.button>
                        </div>

                        {/* Content Scroll Area */}
                        <div style={{
                            padding: '0 32px 40px',
                            overflowY: 'auto',
                            maxHeight: '70vh'
                        }}>
                            <h2 style={{
                                fontFamily: 'var(--fontAnton)',
                                fontSize: '32px',
                                color: 'var(--blue)',
                                lineHeight: '1.2',
                                margin: '0 0 24px 0',
                                textTransform: 'uppercase'
                            }}>
                                {notice.title}
                            </h2>

                            <div style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                gap: '8px', 
                                marginBottom: '24px',
                                color: '#666',
                                fontSize: '13px',
                                fontFamily: 'var(--fontInter)',
                                fontWeight: 500
                            }}>
                                <Calendar size={14} />
                                <span>{notice.publish_date || 'RECENT POST'}</span>
                            </div>

                            <div style={{
                                width: '40px',
                                height: '3px',
                                background: 'var(--blue)',
                                marginBottom: '24px'
                            }} />

                            <div style={{
                                fontFamily: 'var(--fontInter)',
                                fontSize: '18px',
                                lineHeight: '1.6',
                                color: '#333',
                                whiteSpace: 'pre-wrap'
                            }}>
                                {/* Show link content if sub_text is being passed as link */}
                                {notice.link && notice.link !== "#" ? notice.link : notice.title}
                                
                                <p style={{ marginTop: '20px', fontSize: '14px', color: '#666', fontStyle: 'italic' }}>
                                    For further inquiries, please contact the BTCL administration.
                                </p>
                            </div>
                        </div>

                        {/* Footer / Action */}
                        <div style={{
                            padding: '20px 32px',
                            background: '#F8F9FA',
                            display: 'flex',
                            justifyContent: 'flex-end',
                            borderTop: '1px solid #EEE'
                        }}>
                            <motion.button
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.95 }}
                                onClick={onClose}
                                style={{
                                    background: 'var(--blue)',
                                    color: '#fff',
                                    border: 'none',
                                    padding: '10px 24px',
                                    fontFamily: 'var(--fontRajdhani)',
                                    fontWeight: 700,
                                    textTransform: 'uppercase',
                                    cursor: 'pointer',
                                    borderRadius: '4px'
                                }}
                            >
                                Close Information
                            </motion.button>
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}

export default NoticeModal;
